// Navigation menu functionality
(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavbar);
  } else {
    initNavbar();
  }
  
  function initNavbar() {
    const navbar = document.getElementById('navbar');
    if (!navbar) return;
  
    const navTextElements = navbar.querySelectorAll('.nav-text');
    const clothingSubmenu = document.getElementById('clothing-submenu');

    // Handle scroll to change navbar background on all pages
    // Make it globally accessible for other scripts
    window.handleNavbarScroll = function handleScroll() {
      const isDesktop = window.innerWidth >= 1280; // xl breakpoint (desktop nav)
      
      if (window.scrollY > 50) {
        navbar.classList.remove('bg-transparent');
        navbar.classList.add('bg-white');
        // Change text color to dark when background is white
        navTextElements.forEach(element => {
          element.classList.remove('text-white');
          element.classList.add('text-gray-900');
        });
      } else {
        navbar.classList.remove('bg-white');
        navbar.classList.add('bg-transparent');
        // On desktop, keep menu items black; on mobile, make them white for visibility
        navTextElements.forEach(element => {
          if (isDesktop) {
            // Desktop: always keep black for menu items
            element.classList.remove('text-white');
            element.classList.add('text-gray-900');
          } else {
            // Mobile: white text on transparent background for visibility
            element.classList.remove('text-gray-900');
            element.classList.add('text-white');
          }
        });
      }
    };
    
    // Keep local reference for this file
    const handleScroll = window.handleNavbarScroll;
  
    // Set submenu top position to match navbar height exactly (no gap)
    function updateSubmenuPosition() {
      if (clothingSubmenu && navbar) {
        // Get navbar position relative to viewport (since navbar is fixed)
        const navbarRect = navbar.getBoundingClientRect();
        const navbarBottom = navbarRect.bottom;
        const viewportWidth = window.innerWidth;
  
        // Position submenu exactly at navbar bottom with no gap
        if (window.innerWidth >= 1280) {
          // Desktop: fixed positioning with full width - use exact bottom value (no rounding)
          clothingSubmenu.style.position = 'fixed';
          clothingSubmenu.style.top = navbarBottom + 'px';
          // Force left edge of screen - override any parent positioning
          clothingSubmenu.style.left = '0';
          clothingSubmenu.style.right = '0';
          clothingSubmenu.style.width = viewportWidth + 'px';
          clothingSubmenu.style.maxWidth = viewportWidth + 'px';
          clothingSubmenu.style.minWidth = viewportWidth + 'px';
          clothingSubmenu.style.marginLeft = '0';
          clothingSubmenu.style.marginRight = '0';
          clothingSubmenu.style.paddingLeft = '0';
          clothingSubmenu.style.paddingRight = '0';
          // Ensure it breaks out of any parent container constraints
          clothingSubmenu.style.transform = 'none';
        } else {
          // Mobile: reset all desktop styles to allow natural flow
          clothingSubmenu.style.position = '';
          clothingSubmenu.style.top = '';
          clothingSubmenu.style.left = '';
          clothingSubmenu.style.right = '';
          clothingSubmenu.style.width = '';
          clothingSubmenu.style.maxWidth = '';
          clothingSubmenu.style.minWidth = '';
          clothingSubmenu.style.marginLeft = '';
          clothingSubmenu.style.marginRight = '';
          clothingSubmenu.style.paddingLeft = '';
          clothingSubmenu.style.paddingRight = '';
          clothingSubmenu.style.transform = 'none';
          clothingSubmenu.style.webkitTransform = 'none';
          clothingSubmenu.style.mozTransform = 'none';
          clothingSubmenu.style.msTransform = 'none';
        }
      }
    }
  
    // Update submenu position on load and resize
    if (clothingSubmenu) {
      updateSubmenuPosition();
    }
  
    // Add scroll event listener for background change on ALL pages
    window.addEventListener('scroll', handleScroll, { passive: true });
    // Call once on load to set initial state
    handleScroll();
  
    window.addEventListener('resize', updateSubmenuPosition);
    window.addEventListener('scroll', updateSubmenuPosition, { passive: true });
  
    // Update position after any dynamic content loads
    if (document.readyState === 'complete') {
      updateSubmenuPosition();
    } else {
      window.addEventListener('load', updateSubmenuPosition);
    }
  
    // Submenu visibility is now handled by Tailwind CSS classes (group-hover)
    // No JavaScript needed for show/hide functionality
  }
})();